import store from "./_store";
import api from "./_api";


const getLanguage = () => {
	let language = "en-US";
	if (localStorage.getItem("culture")) language = localStorage.getItem("culture");
	else if (navigator.language) {
		if (navigator.language.length == 2) {
			switch (navigator.language) {
				case "en":
					return `${navigator.language}-US`;
				default:
					return `${navigator.language}-${navigator.language.toUpperCase()}`;

			}
		} else {
			language = navigator.language
		}
	}

	localStorage.setItem("culture", language);

	return language;
}

let _versions = {
	items: null,
	apply(translations) {
		this.items = translations || {};
	},
	init(translations, onDone) {
		this.apply(translations);
		if (onDone) onDone();
	},
	isReady() {
		return this.items != null;
	},
	versioned(path) {
		if (!_ui.versions.isReady()) return path;

		let text = path;

		if (text) {
			if (_ui.versions.items[path]) {
				text = _ui.versions.items[path];
			} else if (_ui.versions.items[path.toLowerCase()]) {
				text = _ui.versions.items[path.toLowerCase()];
			}
		}

		// format?
		if (arguments && arguments.length > 1) {
			let args = {};

			for (var index in arguments[1]) {
				args[index - 1] = arguments[1][index];
			}
			return String.format(text, args);
		}
		return text;
	}
};

let _ui = {
	versions: _versions,
	init(vueInstance) {
		const channel = vueInstance.$route.params.channel;
		const url = `${process.env.VUE_APP_HOST_TOCC_TICKETING}/settings/${channel}/translations/${_hub.culture}`;
		api.request(url, null, "GET", null, (response) => {
			this.versions.init(response.Value);
		}, (error) => {
			console.warn("Failed to load translations, default onces used. Errormessage:" + error);
		})
	},
	notificationCenter: {
		isVisible: false,
		isEnabled: true,
		stack: [],
		clear: function () {
			this.stack = [];
		},
		success: function (notification) {
			const {
				title,
				message,
				duration,
				relativeTo
			} = notification;
			this.add(_ui.versions.versioned(title || "save_success"), _ui.versions.versioned(message), "success", duration, relativeTo);
		},
		error: function (notification) {
			const {
				title,
				message,
				duration,
				relativeTo
			} = notification;
			this.add(_ui.versions.versioned(title || "save_error"), message, "error", duration, relativeTo);
		},
		warning: function (notification) {
			const {
				title,
				message,
				duration,
				relativeTo
			} = notification;
			this.add(_ui.versions.versioned(title || "save_warning"), message, "warning", duration, relativeTo);
		},
		add: function (title, message, status, duration, relativeTo) {
			// create notification
			let notification = {
				title: title,
				message: message,
				status: status,
				duration: duration || 5000,
				isVisible: true,
				relativeTo: relativeTo,
			};

			// push notification
			this.stack.push(notification);

			// hide notification after duration
			window.setTimeout(() => {
				notification.isVisible = false;
			}, notification.duration);
		}
	},
};

let _hub = {
	app: {
		isStarted: false,
		isNewPayment: true
	},
	culture: getLanguage(),
	store: store.init(),
	ui: _ui,
	init(vueInstance) {
		//
		this.ui.init(vueInstance);
	},
	isReady() {
		return this.ui.versions != null && this.ui.versions.isReady();
	},
	countryFromIban(param) {
		if (param === null || param.length < 1) return "Deutschland";
		var countryCode = param.substring(0, 2);
		var country;
		switch (countryCode.toUpperCase()) {
			case "AL":
				country = "Albanien";
				break;
			case "AT":
				country = "Österreich";
				break;
			case "BA":
				country = "Bosnien und Herzegowina";
				break;
			case "BE":
				country = "Belgien";
				break;
			case "BG":
				country = "Bulgarien";
				break;
			case "CH":
				country = "Schweiz";
				break;
			case "CY":
				country = "Zypern";
				break;
			case "DE":
				country = "Deutschland";
				break;
			case "DK":
				country = "Dänemark";
				break;
			case "EE":
				country = "Estland";
				break;
			case "ES":
				country = "Spanien";
				break;
			case "FI":
				country = "Finland";
				break;
			case "FR":
				country = "Frankreich";
				break;
			case "GB":
				country = "Großbritanien";
				break;
			case "GR":
				country = "Griechenland";
				break;
			case "HR":
				country = "Griechenland";
				break;
			case "HU":
				country = "Ungarn";
				break;
			case "IE":
				country = "Irland";
				break;
			case "IS":
				country = "Island";
				break;
			case "IT":
				country = "Italien";
				break;
			case "LT":
				country = "Litauen";
				break;
			case "LV":
				country = "Lettland";
				break;
			case "MT":
				country = "Malta";
				break;
			case "NL":
				country = "Niederlande";
				break;
			case "NO":
				country = "Norwegen";
				break;
			case "PL":
				country = "Polen";
				break;
			case "PT":
				country = "Portugal";
				break;
			case "RO":
				country = "Rumänien";
				break;
			case "RS":
				country = "Seribien";
				break;
			case "SE":
				country = "Schweden";
				break;
			case "SI":
				country = "Slowenien";
				break;
			default:
				country = "Undefined";
				break;
		}
		return country;
	},
};

export default _hub;